<template>
  <v-col
    md="5"
    :lg="setColAspect()"
    class="ma-0 pa-0"
    :class="
      is_mobile
        ? 'cart_mobile mobile_height ' + tab
        : 'desktop-height d-flex flex-column border-left ' + tab
    "
  >
    <div class="aviso-devuelto" v-if="order && devuelto(order)">
      <strong><v-icon small color="deep-orange darken-3">mdi-alert-circle-outline</v-icon> La caja te devolvió este pedido</strong>
      <div>Motivo: {{ motivoDevolucion(order) || "sin motivo" }}</div>
      <div v-if="lineasDevueltas(order).length">Cambiar: <strong>{{ lineasDevueltas(order).map((l) => l.name).join(", ") }}</strong></div>
      <div class="caption">Corrígelo y vuelve a enviarlo.</div>
    </div>
    <v-row v-if="order" class="resumen-mesero mt-0" ref="optionsOrder" no-gutters>
      <v-col cols="12" class="px-3 pt-3">
        <div class="mesa-fila" :class="hayMesa() ? 'mesa-fila--lista' : 'mesa-fila--falta'" @click="modalTables = true">
          <v-icon left :color="hayMesa() ? 'success' : 'white'">{{ iconoMesa() }}</v-icon>
          <span class="mesa-fila__texto">{{ textoMesa() }}</span>
          <v-icon v-if="hayMesa()" color="grey darken-1" @click.stop="setTableNull()">mdi-close</v-icon>
          <v-icon v-else color="white">mdi-chevron-right</v-icon>
        </div>
      </v-col>
      <v-col cols="12" class="px-3 py-2 fila-chips">
        <v-chip small outlined color="primary" v-if="!order.data_customer" @click="modalCustomer = true">
          <v-icon left small>mdi-account-search-outline</v-icon>{{ $t("no_client") }}
        </v-chip>
        <v-chip small color="primary" v-else @click="modalCustomer = true">
          <v-icon left small>mdi-account-outline</v-icon>{{ order.getCustomerName() }}
          <v-icon right small @click.stop="removeClient()">mdi-close</v-icon>
        </v-chip>
        <v-chip small :outlined="!order.getNote()" color="primary" @click="noteOrder()">
          <v-icon left small>mdi-comment-text-outline</v-icon>{{ order.getNote() ? "Nota" : "Agregar nota" }}
        </v-chip>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined color="grey darken-1" v-bind="attrs" v-on="on">
              <v-icon left small>mdi-dots-horizontal</v-icon>Más
              <v-icon right x-small color="primary" v-if="activeTip || haveCoupon()">mdi-circle</v-icon>
            </v-chip>
          </template>
          <v-list dense>
            <v-list-item @click.stop="activeTip = !activeTip; changeTip()">
              <v-list-item-icon><v-icon>mdi-hand-heart-outline</v-icon></v-list-item-icon>
              <v-list-item-content><v-list-item-title>{{ $t("tip") }}</v-list-item-title></v-list-item-content>
              <v-list-item-action><v-switch :input-value="activeTip" dense hide-details readonly></v-switch></v-list-item-action>
            </v-list-item>
            <v-list-item @click="modalCoupon = true" :disabled="!$store.getters.getGeneralValue('gen_sales_activate_coupons') && !haveCoupon()">
              <v-list-item-icon><v-icon>mdi-tag-multiple-outline</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ haveCoupon() ? "Cupón: " + order.getCoupon() : "Cupón de descuento" }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="haveCoupon()">
                <v-icon color="red" @click.stop="$pos.setCoupon($pos.getCurrentOrder(), null)">mdi-close</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <!--v-row v-if="order" class="pa-0 ma-0 grey lighten-4" ref="optionsOrder" id="options_order">
      <v-col class="pa-0 ma-0">
       
      </v-col>
    </v-row-->

    <v-divider></v-divider>
    <!-- :key="$store.getters.orderChanged" -->
    <div v-if="order" :style="getHeight()" class="white pa-0 ma-0">
      <v-list shaped class="grey lighten-5">
        <v-list-item
          v-for="item in order.data_items"
          :key="item.id"
          class="cart-item"
        >
          <CartSectionItem
            :item="item"
            :from-waiters="true"
            @delete:item="deleteItem"
            @edit:item="$emit('edit:item', $event)"
            @selectedOptions="$emit('selectedOptions', $event)"
          >
          </CartSectionItem>
          <v-divider></v-divider>
        </v-list-item>
        <!--{{order.data_items}}-->
      </v-list>
    </div>

    <v-row
      v-if="order && ($pos.getCurrentOrder().getPriceTip() > 0 || $pos.getCurrentOrder().getPriceDomicile() > 0)"
      class="pa-0 ma-0"
      ref="totalsSection"
      id="totals_section"
    >
      <v-col class="pa-0 ma-0">
        <v-simple-table class="font-weight-black">
          <tbody>
            <tr class="">
              <td></td>
              <td
                class="font-weight-regular"
                v-if="
                  $pos.getCurrentOrder().getPriceTip() > 0 ||
                  $pos.getCurrentOrder().getPriceDomicile() > 0
                "
              >
                {{ $t("subtotal") }}:
              </td>
              <td v-else>
                <span class="font-weight-regular">{{ $t("total") }}:</span>
              </td>
              <td>
                {{
                  $filters.currency($pos.getCurrentOrder().getTotalToPay(), 0)
                }}
              </td>
            </tr>

            <tr
              v-if="
                $pos.getCurrentOrder().getPriceTip() > 0 ||
                $pos.getCurrentOrder().getPriceDomicile() > 0
              "
            >
              <td
                :key="'tip_' + $store.getters.orderChanged"
                class="font-weight-regular"
              >
                <div v-if="$pos.getCurrentOrder().getPriceTip() > 0">
                  {{ $t("tip") }}:
                  <v-chip
                    color="green lighten-4"
                    class="font-weight-regular black--text green--text text--darken-1"
                  >
                    {{
                      $filters.currency($pos.getCurrentOrder().getPriceTip(), 0)
                    }}
                    <v-icon small @click="modalTip = true" right
                      >mdi-pencil</v-icon
                    >
                  </v-chip>
                </div>
              </td>
              <td class="font-weight-regular">{{ $t("total") }}:</td>
              <td>
                {{
                  $filters.currency(
                    $pos.getCurrentOrder().getPriceTotalWithAdds(),
                    0
                  )
                }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0" id="cart_options">
      <v-col class="pa-0 ma-0">
        <v-btn
          class="white--text"
          depressed
          tile
          block
          x-large
          color="primary"
          @click="saveOrderSeller()"
          :disabled="$pos.getCurrentOrder().isEmpty()"
          :loading="enviando"
        >
          <v-icon left>{{ necesitaMesa() ? "mdi-table-furniture" : "mdi-send" }}</v-icon>
          {{ textoBoton() }}</v-btn
        >
      </v-col>
    </v-row>
    <CartCustomer
      :para-mesero="true"
      :dialog="modalCustomer"
      @cancel="modalCustomer = false"
      @selected="selectedCustomer"
    >
    </CartCustomer>
    <CartPayments
      :dialog="modalPayments"
      @cancel="cancelPayment"
      :order="$pos.getCurrentOrder()"
      :is_mobile="is_mobile"
    >
    </CartPayments>
    <CartAnnulOrder
      :dialog="anullCurrentOrder"
      :order="$pos.getCurrentOrder()"
      :message="$t('really_cancel_order')"
      @close="anullCurrentOrder = false"
      @annul="annulOrder($event)"
    ></CartAnnulOrder>
    <CartNote
      :dialog="modalNote"
      :order="$pos.getCurrentOrder()"
      @cancel="modalNote = false"
      @close="modalNote = false"
    >
    </CartNote>
    <CartCoupon
      :dialog="modalCoupon"
      :order="$pos.getCurrentOrder()"
      @cancel="modalCoupon = false"
      @close="modalCoupon = false"
    ></CartCoupon>
    <CartTip
      :dialog="modalTip"
      :order="$pos.getCurrentOrder()"
      @cancel="modalTip = false"
      @modalSetAutomaticTip="modalSetAutomaticTip()"
      @close="modalTip = false"
    ></CartTip>

    <div v-if="modalTables">
      <CartTablesRemote
        :dialog="modalTables"
        :order="$pos.getCurrentOrder()"
        allow-pickup
        @cancel="modalTables = false"
        @close="modalTables = false"
      ></CartTablesRemote>
    </div>

    <ModalTryAgain ref="modalTryAgain" @try-save-order="saveOrderSeller()" />

    <v-dialog v-model="errorEnvio" max-width="420" persistent>
      <v-card>
        <v-card-title class="d-flex flex-column pa-4" style="word-break: normal">
          <v-icon class="red lighten-5 pa-3 mb-3 rounded-pill" size="40" color="red">mdi-wifi-off</v-icon>
          <h3 class="font-weight-bold red--text text-center">No se pudo enviar el pedido</h3>
        </v-card-title>
        <v-card-text class="text-center">
          {{ mensajeError }} Tu pedido sigue aquí, no se perdió.
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-btn large outlined color="primary" @click="errorEnvio = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn large depressed color="primary" @click="reintentarEnvio">
            <v-icon left>mdi-reload</v-icon>Reintentar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="enviado" top color="#2e7d5b" :timeout="3500" class="mt-16">
      <v-icon left color="white">mdi-check-circle</v-icon>{{ mensajeEnviado }}
    </v-snackbar>
  </v-col>
</template>




<script>
import CartSectionItem from "./../pos/components/CartSectionItem";
import CartCustomer from "./../pos/components/CartCustomer";
import CartPayments from "./../pos/components/CartPayments";
import CartAnnulOrder from "./../pos/components/CartAnnulOrder";
import CartNote from "./../pos/components/CartNote";
import CartTables from "./../pos/components/CartTables";
import CartCoupon from "./../pos/components/CartCoupon";
import CartTip from "./../pos/components/CartTip";
import CartTablesRemote from "./../pos/components/CartTablesRemote";
import { isStoreActive } from "@/plugins/db-firestore";
import { esDevuelto, motivoDevolucion, lineasDevueltas } from "@/plugins/pedidos-rechazados";
import ModalTryAgain from "./../pos/components/ModalTryAgain.vue";
export default {
  name: "CartSection",
  components: {
    CartSectionItem,
    CartCustomer,
    CartPayments,
    CartAnnulOrder,
    CartNote,
    CartTables,
    CartTablesRemote,
    CartCoupon,
    CartTip,
    ModalTryAgain,
  },
  props: ["is_mobile", "aspect_ratio", "modeSeller"],
  data: () => ({
    tab: null,
    vHeight: 67,
    order: null,
    modalCoupon: false,
    modalCustomer: false,
    modalPayments: false,
    modalNote: false,
    modalTip: false,
    modalTables: false,
    anullCurrentOrder: false,
    employees: [],
    sellers: [],
    domiciliaries: [],
    domiciliary: null,
    seller: null,
    price_delivery: null,
    activeTip: false,
    activeInvoiceElectronic: false,
    orderType: "is_on_table",
    enviando: false,
    errorEnvio: false,
    mensajeError: "",
    enviado: false,
    mensajeEnviado: "",
  }),

  watch: {
    "$store.getters.orderChanged": function () {
      //this.order = this.$pos.getCurrentOrder();
      //console.log("order changed .................................");
      this.$set(this, "order", this.$pos.getCurrentOrder());
      this.setDefaultsOnChargeOrder();
    },
  },
  //props: ['order'],
  mounted() {
    this.order = this.$pos.getCurrentOrder();
    setTimeout(() => {
      this.setDefaultsOnChargeOrder();
      this.getEmployees();

      /* */
    }, 200);
  },
  methods: {
    motivoDevolucion,
    lineasDevueltas,
    devuelto(o) {
      return esDevuelto(o);
    },
    getPendingOrder(id) {
      this.$http.get("api/v1/orders-pending", { id: id }).then((response) => {
        //this.orders = response.items;
        this.$db.updateOrders(response.items);
      });
    },
    setTableNull() {
      // Primero la marca de «para llevar»: no es reactiva y el aviso de cambio lo dan los setters de abajo.
      this.$pos.getCurrentOrder().waiter_pickup = false;
      this.$pos.setNameTable(this.$pos.getCurrentOrder(), null);
      this.$pos.setIsOnTable(this.$pos.getCurrentOrder(), false);
      this.$pos.setStorePickup(this.$pos.getCurrentOrder(), true);
    },
    allowedPayment() {
      let order = this.$pos.getCurrentOrder();
      if (order.is_electronic_invoice) {
        if (!order.data_customer) {
          return false;
        }
      }
      return true;
    },
    activateCoupons() {
      return true;
    },
    activateDomicilies() {
      return false;
    },
    async getValueActivePrintRemote() {
      let value = false;
      let installation = this.$store.getters.installation;
      if (installation) {
        const cashRegister = await this.$db.getCashRegister(
          installation.cash_id
        );
        if (cashRegister) {
          if (cashRegister.config) {
            if (cashRegister.config.pos_active_print_remote) {
              value = cashRegister.config.pos_active_print_remote;
            }
          }
        }
      }
      return value;
    },
    pay() {
      if (this.order.is_domicile) {
        if (
          !this.order.data_customer ||
          !this.order.data_customer["first_name"] ||
          !this.order.data_customer["phone"] ||
          !this.order.data_customer["address"]
        ) {
          this.modalCustomer = true;
          return;
        }
      }
      this.modalPayments = true;
    },
    annulOrder(order) {
      this.anullCurrentOrder = false;
      this.createNewOrder();
    },
    haveCoupon() {
      if (this.order.getCoupon()) {
        return true;
      }
      return false;
    },
    cancelPayment(params) {
      if (params) {
        if (params.orderfinalized) {
          this.createNewOrder();
          this.activeTip = false;
          this.activeInvoiceElectronic = false;
        }
      }
      this.modalPayments = false;
    },
    openAnnulOrder() {
      this.anullCurrentOrder = true;
    },
    changeOrderType(type) {
      //ver orden en que estan los botones en el v-btn-toggle
      if (this.orderType == "is_direct") {
        //en_tienda
        this.setVHeight();
        this.$pos.setIsDomicile(this.order, false);
        this.$pos.setIsOnTable(this.order, false);
        this.$pos.setNameTable(this.order, null);
        this.$pos.setStorePickup(this.order, true);
        this.$pos.setPriceDomicile(this.order, 0);
        this.$pos.setDomiciliary(null);
      }
      if (this.orderType == "is_on_table") {
        this.setVHeight();
        this.modalTables = true;
        this.$pos.setIsOnTable(this.order, true);
        this.$pos.setIsDomicile(this.order, false);
        this.$pos.setStorePickup(this.order, false);
        this.$pos.setPriceDomicile(this.order, 0);
        this.$pos.setDomiciliary(null);
      }
      if (this.orderType == "is_domicile") {
        //domicilios
        this.setVHeight();
        this.$pos.setIsDomicile(this.order, true);
        this.$pos.setIsOnTable(this.order, false);
        this.$pos.setNameTable(this.order, null);
        this.$pos.setStorePickup(this.order, false);
      }
    },
    electronicInvoiceHint() {
      return this.$t("invoice_electronic");
    },
    getIsSellDoorToDoor() {
      let value = this.$store.getters.getGeneralValue(
        "gen_sales_activate_door_to_door_sales"
      );
      return value;
    },
    // «Para llevar» lo marca el mesero (waiter_pickup); un pedido que viene del servidor (tiene id) ya
    // dice si es para llevar o domicilio con store_pickup / is_domicile.
    sinMesaValida(o) {
      return !!o && (o.waiter_pickup === true || (!!o.id && (o.store_pickup === true || o.is_domicile === true)));
    },
    hayMesa() {
      const o = this.order;
      return !!o && (!!o.getNameTable() || this.sinMesaValida(o));
    },
    textoMesa() {
      const o = this.order;
      if (o && o.getNameTable()) return o.getNameTable();
      if (o && o.is_domicile) return "Domicilio";
      return this.sinMesaValida(o) ? "Para llevar" : "Elegir mesa";
    },
    iconoMesa() {
      const o = this.order;
      if (o && !o.getNameTable() && o.is_domicile) return "mdi-moped-outline";
      return o && !o.getNameTable() && this.sinMesaValida(o) ? "mdi-bag-personal-outline" : "mdi-table-furniture";
    },
    // La orden de un mesero necesita mesa, o marcarse «para llevar».
    necesitaMesa() {
      const o = this.order;
      return !!o && !o.getNameTable() && !this.sinMesaValida(o) && !this.getIsSellDoorToDoor();
    },
    textoBoton() {
      if (this.enviando) return "Enviando…";
      if (this.necesitaMesa()) return "Elegir mesa para enviar";
      if (this.order && !this.order.isEmpty()) {
        return "Enviar pedido · " + this.$filters.currency(this.order.getPriceTotalWithAdds(), 0);
      }
      return "Enviar pedido";
    },
    reintentarEnvio() {
      this.errorEnvio = false;
      this.saveOrderSeller();
    },
    async saveOrderSeller() {
      if (this.enviando) return;
      const isDoorToDoor = this.getIsSellDoorToDoor();
      const orden = this.$pos.getCurrentOrder();
      // Sin mesa (y sin marcar «para llevar») no sale: se abre la ventana para elegirla.
      if (!orden.getNameTable() && !this.sinMesaValida(orden) && !isDoorToDoor) {
        this.modalTables = true;
        return;
      }
      if (isDoorToDoor && (!orden.data_customer || !orden.data_customer.identification)) {
        alert('Es obligatorio asignar un cliente, si no existe añadir el documento y rellenar la información solicitada');
        return;
      }
      this.enviando = true;
      try {
        if (!isDoorToDoor) {
          // Si la consulta a la caja falla (sin internet), se avisa y la orden se conserva.
          const installation = this.$store.getters.installation;
          let active;
          try {
            active = await isStoreActive(installation.subsidiary_id, 1);
          } catch (e) {
            throw new Error("No se pudo comprobar la conexión con la caja.");
          }
          if (!active) {
            this.$refs.modalTryAgain.renderItem();
            return;
          }
        }
        this.$pos.setOrderStatus(orden, "pending");
        const mesa = orden.getNameTable();
        const productos = Math.ceil(orden.getTotalItems());
        const response = await this.$pos.saveOrderSeller(orden, this.$http, true);
        if (response && response.success === false) {
          // El servidor contestó con un error y ya se le mostró al mesero: la orden se conserva.
          return;
        }
        this.mensajeEnviado = `Pedido enviado · ${mesa || (orden.is_domicile ? "Domicilio" : "Para llevar")} · ${productos} ${productos === 1 ? "producto" : "productos"}`;
        this.enviado = true;
        this.createNewOrder();
        // El pedido ya salió: se vuelve a la lista de productos, lista para el siguiente.
        this.$emit("created:order");
      } catch (e) {
        this.mensajeError = typeof e === "string" ? e : (e && e.message) || "Revisa la conexión a internet.";
        this.errorEnvio = true;
      } finally {
        this.enviando = false;
      }
    },
    createNewOrder() {
      let defaults = { is_on_table: true, from_seller: true };
      this.$pos.createOrder(false, defaults);
      this.$store.dispatch("createdOrder");
    },
    async save() {
      this.$pos.setOrderStatus(this.$pos.getCurrentOrder(), "received");
      /*if (this.$pos.getCurrentOrder().getIsOnTable()) {
        let name_table = this.$pos.getCurrentOrder().getNameTable();
        if (name_table) {
          let table = await this.$db.getTableByName(name_table);
          await this.$db.updateTableBusy(table, true);
        }
      }*/
      this.$pos.saveOrder(this.$pos.getCurrentOrder(), this.$http);

      this.createNewOrder();
    },
    selectedCustomer(customer) {
      this.$pos.setCustomer(customer);
      this.modalCustomer = false;
    },
    deleteItem(itemLine) {
      //si la orden ya se imprimio debe escribir un motivo, se guarda el motivo en la orden
      this.$pos.deleteItem(itemLine);
      this.$pos.setPriceTip(this.$pos.getCurrentOrder(), null);
    },
    removeClient() {
      this.$pos.setCustomer(null);
      this.modalCustomer = false;
    },
    noteOrder() {
      this.modalNote = true;
    },
    openModalCoupon() {
      this.modalCoupon = true;
    },
    openModalTables() {
      this.modalTables = true;
    },
    openModalTip() {
      this.modalTip = true;
    },
    changeSeller(evt) {
      this.$pos.setSeller(evt);
    },
    changeDomiciliary(evt) {
      this.$pos.setDomiciliary(evt);
    },
    changePriceDelivery(evt) {
      if (evt) {
        this.$pos.setPriceDomicile(this.order, parseInt(evt));
      } else {
        this.$pos.setPriceDomicile(this.order, 0);
      }
    },
    changeInvoiceElectronic() {
      if (this.activeInvoiceElectronic) {
        let order = this.$pos.getCurrentOrder();
        if (!order.data_customer) {
          this.modalCustomer = true;
        }
      }

      this.$pos.setIsElectronicInvoice(
        this.order,
        this.activeInvoiceElectronic
      );
    },
    changeTip() {
      this.$pos.setActiveTip(this.$pos.getCurrentOrder(), this.activeTip);
      if (this.activeTip) {
        this.$pos.setPriceTip(this.order, null);
      } else {
        this.$pos.setPriceTip(this.order, 0);
      }
      this.setVHeight();
    },
    printRemote() {
      if (this.order.getTotalItemsPrintRemote() > 0) {
        this.$pos.printRemote(this.order, false);
      } else {
        this.$pos.printRemote(this.order, true);
      }
    },
    printScreen() {
      this.$pos.printReceiptScreen(this.order);
    },
    setColorNote() {
      if (this.order.getNote()) {
        return "primary";
      }
    },
    setDefaultsOnChargeOrder() {
      if (this.order.getIsOnTable()) {
        this.orderType = "is_on_table";
      } else if (this.order.getIsDomicile()) {
        this.orderType = "is_domicile";
      } else {
        this.orderType = "is_direct";
      }

      if (this.order.getPriceTip() > 0) {
        this.activeTip = true;
      }

      if (this.order.getIsElectronicInvoice()) {
        this.activeInvoiceElectronic = true;
      }

      if (this.order.getBusPersonDomiciliaryId()) {
        this.domiciliary = this.order.getDataDomiciliary();
      } else {
        this.domiciliary = null;
      }

      if (this.order.getBusPersonSellerId()) {
        this.seller = this.order.getDataSeller();
      } else {
        this.seller = null;
      }

      if (this.order.getPriceDomicile() && this.order.getPriceDomicile() > 0) {
        this.price_delivery = this.order.getPriceDomicile();
      }
      this.setVHeight();
    },
    getHeight() {
      // En el celular la lista sigue a la página y deja sitio a la barra de abajo (total y botón).
      if (this.is_mobile) {
        return "overflow-y:auto; padding-bottom: 150px;";
      }
      // En tablet y pantalla ancha el pedido ocupa su columna: la lista toma el espacio que sobra.
      return "overflow-y:auto; flex: 1 1 auto; min-height: 0;";
    },
    setVHeight() {},
    async getEmployees() {
      const sellers = await this.$db.getEmployeesByType("seller");
      this.sellers = sellers;
      const domiciliaries = await this.$db.getEmployeesByType("deliverer");
      this.domiciliaries = domiciliaries;
    },
    modalSetAutomaticTip($event) {},
    setColspanMobile(value) {
      if (this.is_mobile) {
        return value;
      }
      return 1;
    },
    setColAspect() {
      const aspect = ["5:4", "4:3", "16:9", "16:10"];
      if (this.aspect_ratio) {
        if (this.aspect_ratio.aspect_ratio) {
          if (this.inArray(this.aspect_ratio.aspect_ratio, aspect)) {
            return 5;
          }
        }
      }
      return 4;
    },
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.aviso-devuelto {
  margin: 12px 12px 0;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #bf360c;
  background: rgba(244, 81, 30, 0.1);
  border: 1px solid #f4511e;
}

.resumen-mesero {
  flex: 0 0 auto;
  align-content: flex-start;
}

.mesa-fila {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 14px;
  border-radius: 12px;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}

.mesa-fila--falta {
  background: #f57c00;
  color: #fff;
}

.mesa-fila--lista {
  background: #fff;
  border: 2px solid #4caf50;
  color: rgba(0, 0, 0, 0.87);
}

.mesa-fila__texto {
  flex: 1;
}

.fila-chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
}

.fila-chips::-webkit-scrollbar {
  display: none;
}

.btn-pay {
  background: #56ab2f;
  background: -webkit-linear-gradient(to right, #a8e063, #56ab2f);
  background: linear-gradient(to right, #a8e063, #56ab2f);
}

.btn-save {
  background: #00b4db;
  background: -webkit-linear-gradient(to left, #0083b0, #00b4db);
  background: linear-gradient(to left, #0083b0, #00b4db);
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(0, 0, 0, 0.05) !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  background: none;
}

.v-btn-toggle > .v-btn.v-btn {
  border-style: none;
}

.v-item--active {
  border: none !important;
  background: #e4e4e4 !important;
  color: #24a9e1;
  font-size: 0.875rem;
}

.v-item--active .v-icon,
.v-item--active .v-btn__content span {
  /* color: #24A9E1 !important; */
  color: #24a9e1 !important;
}

.v-btn:before {
  background-color: #e4e4e4 !important;
}
</style>

<style>
@media only screen and (max-width: 981px) {
  #totals_section {
    bottom: 5ch;
  }

  #cart_options {
    bottom: 0;
    background: #fafafa;
  }

  #totals_section,
  #cart_options {
    position: fixed;
    z-index: 100;
    width: 100%;
  }
}

.desktop-height {
  height: calc(100vh - 70px) !important;
}

.mobile-height {
  height: calc(100vh - 14ch) !important;
}

.cart_options .v-select > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
}

.cart_options .v-text-field > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
}

.cart_options .v-input--switch > .v-input__control > .v-input__slot label {
  color: rgba(0, 0, 0, 1);
  font-size: 0.875rem !important;
  font-weight: 400 !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.cart_coupon_fix span {
  top: -5px;
}
</style>